import { type ButtonHTMLAttributes, type ReactNode } from 'react'
import { cn } from '../lib/utils'

interface PillButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active: boolean
  children: ReactNode
}

export function PillButton({ active, children, className, ...rest }: PillButtonProps) {
  return (
    <button
      className={cn(
        'px-3 py-1 rounded-full text-sm font-medium transition-colors cursor-pointer',
        active
          ? 'bg-primary text-primary-foreground'
          : 'text-muted-foreground hover:text-foreground',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  )
}
